import axios from "axios";
import { API_URL } from "@/config";
import i18n from "@/lib/i18n";

export default {
  namespaced: true,

  actions: {
    async create(_, helpTicketData) {
      const response = await axios.post(`${API_URL}/helpTickets`, helpTicketData);

      if (!response.status || response.status !== 200) {
        throw new Error(i18n.t("Error occurred while processing your request."));
      }

      return response.data;
    },
  },
};
